import { Typography } from '@navi/web-ui/lib/primitives';
import { useNavigate } from 'react-router';
import APP_ROUTES from '@cp/src/layout/Routes';
import { IAmeyoUtility } from '../AmeyoUtility/interfaces';
import styles from './allocationServices.module.scss';
import AllocationIcon from '@cp/src/assets/icons/AllocationIcon';
import DeallocationIcon from '@cp/src/assets/icons/DeallocationIcon';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { Roles } from '../auth/constants/AuthConstants';
import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import { useMemo } from 'react';

const AgencyAllocation = () => {
  const navigate = useNavigate();
  const handleCardClick = (topath: IAmeyoUtility) => {
    navigate(topath.path);
  };
  const featureFlags = useSelector((state: RootState) => state?.common?.featureFlags);
  const { allocateCaseToAgency = false } = featureFlags || {};
  const cardData = useMemo(() => {
    return [
      {
        icon: <AllocationIcon />,
        text: 'Allocation',
        onClick: () => handleCardClick(APP_ROUTES.ALLOCATE_CASES_FOR_AGENCY),
        isVisible: allocateCaseToAgency
      },
      {
        icon: <DeallocationIcon />,
        text: 'Deallocation',
        onClick: () => handleCardClick(APP_ROUTES.DEALLOCATE_CASES_FOR_AGENCY),
        isVisible: allocateCaseToAgency
      }
    ];
  }, []);

  return (
    <div>
      <div className={styles.topNavContainer}>
        <div className={cx('cursor-pointer')} onClick={() => navigate(-1)}>
          <BackIcon size={'16'} />
        </div>
      </div>

      <div className={styles.container}>
        <Typography variant="h3" className={cx(styles.headerContainer, 'text-center !w-full')}>
          Allocation services for Agencies
        </Typography>
        <Typography variant="h4" className={styles.subHeaderContainer}>
          What would you like to do?
        </Typography>
        <div className={styles.subContainer}>
          {cardData?.map(
            (card, text) =>
              card.isVisible && (
                <div key={text} className={styles.card} onClick={card.onClick}>
                  {card.icon}
                  <Typography variant="h4" className={styles.cardContent}>
                    {card.text}
                  </Typography>
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default AgencyAllocation;
